export function getScssImports() {
    return "@import 'globals/mixins';\n@import 'globals/global-variables';\n";
}

//function checks if provided path root is scss 
//and then proceeds to generate imports
//with relative paths to 'scss/globals/mixins'
//and 'scss/globals/global-variables

export function getScssImportsWithRelativePath(srcPath) {
    srcPath = srcPath.toString();
    if (!srcPath.startsWith('scss/')) {
        throw new Error("attempting to import scss mixins while not in scss directory");
    }
    const neededBacks = srcPath.split('/').length - 2;
    if (neededBacks < 1) {
        return getScssImports();
    }
    const backString = "../".repeat(neededBacks);
    const imports = `@import '${backString}globals/mixins';\n@import '${backString}globals/global-variables';\n`;


    return imports;

}

export default getScssImports;